import { render, staticRenderFns } from "./_IbxPassageCard.vue?vue&type=template&id=2ad047af"
import script from "./_IbxPassageCard.vue?vue&type=script&lang=js"
export * from "./_IbxPassageCard.vue?vue&type=script&lang=js"
import style0 from "./_IbxPassageCard.vue?vue&type=style&index=0&id=2ad047af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports